import { useMemo } from "react";
import { Periodo } from "../__types";

export const useExisteAnoVigente = (periodos: Periodo[]) => {
    return useMemo(() => {
        const anoAtual = new Date().getFullYear();
        return periodos.some((p) => {
            const ano = String(p.periodo).split('-')[0];
            return ano === String(anoAtual);
        });
    }, [periodos]);
};
